import { render } from "./Rough.vue?vue&type=template&id=5d1dc123"
import script from "./Rough.vue?vue&type=script&lang=js"
export * from "./Rough.vue?vue&type=script&lang=js"

import exportComponent from "D:\\shiv_mfg_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__